export default "__VITE_ASSET__CHD51Uyg__"